import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        this.$sliderBackground = this.$('background')[0];
        this.$sliderContent = this.$('content')[0];

    }

    init() {
        this.swiperBackground = new Swiper(this.$sliderBackground, {
            speed: 1200,
            loop: false,
            allowTouchMove: false,
            loopAdditionalSlides: 2,
            effect: "creative",
            creativeEffect: {
                prev: {
                    shadow: true,
                    translate: ["0%", 0, -1],
                    scale: 1.1,
                    opacity: 0
                },
                next: {
                    translate: ["0%", 0, 0],
                    scale: 1.2,
                    opacity: 0
                }
            }
        });

        this.swiperContent = new Swiper(this.$sliderContent, {
            speed: 1200,
            loop: false,
            allowTouchMove: false,
            loopAdditionalSlides: 2,
            effect: "creative",
            creativeEffect: {
                prev: {
                    opacity: 0
                },
                next: {
                    opacity: 0
                }
            },
            pagination: {
                el: '.c-home-hero_pagination',
                type: 'bullets',
                clickable: true
            },
        });

        this.swiperContent.controller.control = this.swiperBackground;
        this.swiperBackground.controller.control = this.swiperContent;

        this.launch();
        this.events();
        this.oldIndex = 0;

        this.on('validate','AgeGate',this.launch);
    }

    launch() {
        // glitch to properly launch the pagination
        
        this.swiperContent.slideTo(1);
        setTimeout(() => {
            this.swiperContent.slideTo(0);
        }, 150);
    }

    events() {
        // this.swiperContent.on('beforeSlideChangeStart',(e) => this.beforeSlideChangeStart(e))
        // this.swiperContent.on('slideChangeTransitionStart',(e) => this.slideChangeTransitionStart(e))
        // this.swiperContent.on('slideChangeTransitionEnd',(e) => this.transitionEnd(e))
    }


    transitionEnd(e) {
    }
}
